import Button from 'components/button'
import Dropdown from 'components/dropdown'
import DropdownMenu from 'components/dropdown_menu'
import React, { Component } from 'react'
import styles from './setting_dropdown.module.scss'

export default class SettingDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpened: false
    }
  }

  toggleOpenState() {
    const { isOpened } = this.state

    this.setState({
      isOpened: !isOpened
    })
  }

  render() {
    const { isOpened } = this.state

    return (
      <Dropdown className={styles.dropdown} show={isOpened}>
        <Button
          className={styles.toggle}
          icon="ic-settings"
          iconClassName={styles.icon}
          iconOnly
          none
          onClick={() => this.toggleOpenState()}
        >
          <div className={styles.caret} />
        </Button>
        <DropdownMenu className={styles.menu} show={isOpened} onClick={() => this.toggleOpenState()}>
          <a href={Routes.editManagerRegistrationPath()} className={styles.item}>
            {I18n.t('components.app_header.setting_dropdown.account_setting')}
          </a>
          <a href={Routes.destroyManagerSessionPath()} data-method="delete" className={styles.item}>
            {I18n.t('components.app_header.setting_dropdown.logout')}
          </a>
        </DropdownMenu>
      </Dropdown>
    )
  }
}
